const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const NEW_VIEW_TOTAL = 426143;
const DATA_POINT_VIEWS = 420552;

const SCALE_FACTOR = (NEW_VIEW_TOTAL / DATA_POINT_VIEWS);


module.exports.reportData = {
  info: {
    campaignName: 'AccorHotels – What Happens In Paris Stays In Paris',
    influencerName: 'Callux and Sarah',
    reportDate: new Date('2018-05-30'),
    campaignHashTag: '#accorhotels',
    campaignSponsorHandle: '@Accorhotels',
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/brave-bison-sky-westworld.zip',
    logo: {
      src: '/images/afterparty-logo.png',
      alt: 'Afterparty Studios',
      height: 100,
    }
  },
  youtubeViews: NEW_VIEW_TOTAL,
  youtubeEngagements: 38773 * SCALE_FACTOR,
  scaleFactor: SCALE_FACTOR,
  heroData: {
    main: {
      title: 'SURPRISING MY GIRLFRIEND',
      subTitle: `I’m such a great boyfriend!
Thanks to https://www.AccorHotels.com for the video challenge and sponsoring this video :)
Watch me being pranked by Greg here: https://www.youtube.com/watch?v=U0qxH...`,
      videoUrl: 'https://www.youtube.com/watch?v=YIyzeywKuYo',
      views: NEW_VIEW_TOTAL,
      engagements: 26669 * SCALE_FACTOR,
      watchTimeUKIre: 950778 * SCALE_FACTOR,
      watchTimeTotal: 1761470 * SCALE_FACTOR,
      scaleFactor: SCALE_FACTOR,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [89.9, 10.1],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [8.8, 41, 26.5, 6.9, 5.1, 0.7, 0.9],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.4, 5.3, 1.7, 0.7, 0.7, 0.1, 0.1],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 901003,
        views: 199090,
        likes: 11831,
      },
      {
        name: 'France',
        watchTime: 228071,
        views: 73877,
        likes: 3778,
      },
      {
        name: 'United States',
        watchTime: 100426,
        views: 22564,
        likes: 1454,
      },
      {
        name: 'Australia',
        watchTime: 70019,
        views: 14840,
        likes: 943,
      },
      {
        name: 'Ireland',
        watchTime: 49785,
        views: 11074,
        likes: 741,
      },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report2/data/accor-hotels.js